import {useMemo} from "react";

export const useSnackbarStyle = ({ type, theme: { palette } }) => {
    const isDark = palette.mode === 'dark';

    const backgroundColor = useMemo(() => {
        const rawColor = (() => {
            switch (type) {
                case 'success':
                    return palette.success.alert;
                case 'error':
                    return palette.error.alert;
                case 'warning':
                    return palette.warning.light;
                case 'info':
                default:
                    return palette.primary.alert;
            }
        })();

        // In dark mode, strip the alpha from rgba backgrounds so they are fully opaque
        if (isDark) {
            const match = rawColor?.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
            if (match) {
                return `rgb(${match[1]}, ${match[2]}, ${match[3]})`;
            }
        }

        return rawColor;
    }, [type, palette, isDark]);

    const textColor = useMemo(
        () => isDark ? '#fff' : palette.getContrastText(backgroundColor),
        [backgroundColor, palette, isDark]
    );

    return useMemo(
        () => ({ '--backgroundColor': backgroundColor, '--textColor': textColor }),
        [backgroundColor, textColor]
    );
};
